import React from "react";
import { CatalogEntriesPage } from "./CatalogEntriesPage";
import { useCatalogEntries } from "./useCatalogEntries";

function CatalogEntries() {
  return <CatalogEntriesPage {...useCatalogEntries()} />;
}

export default CatalogEntries;
